var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPasswordEye = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9794AA",
  d: "m19.883 4.881-.736-.736c-.208-.208-.592-.176-.832.112l-2.56 2.544c-1.153-.496-2.417-.736-3.745-.736-3.952.016-7.376 2.32-9.024 5.632-.096.209-.096.464 0 .64a9.86 9.86 0 0 0 3.36 3.84L4.25 18.305c-.24.24-.272.624-.112.832l.736.736c.208.208.592.176.832-.112L19.754 5.713c.304-.24.336-.623.128-.831m-7.025 4.832c-.272-.064-.56-.144-.832-.144a2.44 2.44 0 0 0-2.448 2.448c0 .272.064.56.144.832L8.65 13.905a3.73 3.73 0 0 1-.496-1.888 3.83 3.83 0 0 1 3.84-3.84c.704 0 1.328.176 1.888.496zM21.034 11.697c-.56-1.12-1.296-2.128-2.207-2.944l-2.977 2.944v.32a3.83 3.83 0 0 1-3.84 3.84h-.32l-1.888 1.888c.705.144 1.44.24 2.16.24 3.953 0 7.376-2.304 9.025-5.632a.65.65 0 0 0 .048-.656"
})));
export { SvgPasswordEye as ReactComponent };
export default __webpack_public_path__ + "assets/images/password_eye.svg";